import React from 'react'
import RFI from '../../components/DocumentWorkflow/RFI/RFI.js'

const RFI_View = () => {
	return (
		<div>
			<RFI />
		</div>
	)
}


export default RFI_View